module.exports = __webpack_public_path__ + "assets/images/bag.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/bag.png
// module id = 1490
// module chunks = 1